import { render, staticRenderFns } from "./PainelEscala.vue?vue&type=template&id=33d10384"
import script from "./PainelEscala.vue?vue&type=script&lang=js"
export * from "./PainelEscala.vue?vue&type=script&lang=js"
import style0 from "./PainelEscala.vue?vue&type=style&index=0&id=33d10384&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports